<template>
<div class="chapter">
<div class="inner_page">
<p class="normalf"><a id="page_5"></a><i>To Shelby and Sydney, may your lives be filled with endless beautify with only a few freckles of despair</i>.</p>
<p class="rightf"><i>Your loving Mother</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter01.vue?34b5bf33